var _rect, _path, _g, _path2, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 6.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.136 21.7511C65.784 21.7511 63.867 23.5401 63.867 26.0041C63.867 28.4531 65.784 30.2571 68.136 30.2571C70.489 30.2571 72.406 28.4531 72.406 26.0041C72.405 23.5401 70.488 21.7511 68.136 21.7511ZM68.136 28.5831C66.847 28.5831 65.736 27.5201 65.736 26.0051C65.736 24.4741 66.848 23.4271 68.136 23.4271C69.425 23.4271 70.536 24.4741 70.536 26.0051C70.536 27.5191 69.425 28.5831 68.136 28.5831ZM58.822 21.7511C56.47 21.7511 54.553 23.5401 54.553 26.0041C54.553 28.4531 56.47 30.2571 58.822 30.2571C61.175 30.2571 63.092 28.4531 63.092 26.0041C63.092 23.5401 61.175 21.7511 58.822 21.7511ZM58.822 28.5831C57.533 28.5831 56.422 27.5201 56.422 26.0051C56.422 24.4741 57.534 23.4271 58.822 23.4271C60.111 23.4271 61.222 24.4741 61.222 26.0051C61.223 27.5191 60.111 28.5831 58.822 28.5831ZM47.744 23.0571V24.8611H52.062C51.933 25.8761 51.595 26.6171 51.079 27.1321C50.451 27.7601 49.468 28.4531 47.744 28.4531C45.086 28.4531 43.008 26.3101 43.008 23.6521C43.008 20.9941 45.086 18.8511 47.744 18.8511C49.178 18.8511 50.225 19.4151 50.998 20.1401L52.271 18.8671C51.191 17.8361 49.758 17.0471 47.744 17.0471C44.103 17.0471 41.042 20.0111 41.042 23.6521C41.042 27.2931 44.103 30.2571 47.744 30.2571C49.709 30.2571 51.192 29.6121 52.351 28.4041C53.543 27.2121 53.914 25.5361 53.914 24.1831C53.914 23.7651 53.882 23.3781 53.817 23.0561H47.744V23.0571ZM93.052 24.4581C92.698 23.5081 91.618 21.7511 89.411 21.7511C87.22 21.7511 85.399 23.4751 85.399 26.0041C85.399 28.3881 87.204 30.2571 89.62 30.2571C91.569 30.2571 92.697 29.0651 93.165 28.3721L91.715 27.4051C91.232 28.1141 90.571 28.5811 89.62 28.5811C88.67 28.5811 87.993 28.1461 87.558 27.2921L93.245 24.9401L93.052 24.4581ZM87.252 25.8761C87.204 24.2321 88.525 23.3951 89.476 23.3951C90.217 23.3951 90.845 23.7661 91.055 24.2971L87.252 25.8761ZM82.629 30.0001H84.497V17.4991H82.629V30.0001ZM79.567 22.7021H79.503C79.084 22.2021 78.278 21.7511 77.264 21.7511C75.137 21.7511 73.188 23.6201 73.188 26.0211C73.188 28.4051 75.137 30.2581 77.264 30.2581C78.279 30.2581 79.084 29.8071 79.503 29.2921H79.567V29.9041C79.567 31.5311 78.697 32.4011 77.296 32.4011C76.152 32.4011 75.443 31.5801 75.153 30.8871L73.526 31.5641C73.993 32.6911 75.233 34.0771 77.296 34.0771C79.487 34.0771 81.34 32.7881 81.34 29.6461V22.0101H79.568V22.7021H79.567ZM77.425 28.5831C76.136 28.5831 75.057 27.5031 75.057 26.0211C75.057 24.5221 76.136 23.4271 77.425 23.4271C78.697 23.4271 79.696 24.5221 79.696 26.0211C79.696 27.5031 78.697 28.5831 77.425 28.5831ZM101.806 17.4991H97.335V30.0001H99.2V25.2641H101.805C103.873 25.2641 105.907 23.7671 105.907 21.3821C105.907 18.9971 103.874 17.4991 101.806 17.4991ZM101.854 23.5241H99.2V19.2391H101.854C103.249 19.2391 104.041 20.3941 104.041 21.3821C104.041 22.3501 103.249 23.5241 101.854 23.5241ZM113.386 21.7291C112.035 21.7291 110.636 22.3241 110.057 23.6431L111.713 24.3341C112.067 23.6431 112.727 23.4171 113.418 23.4171C114.383 23.4171 115.364 23.9961 115.38 25.0251V25.1541C115.042 24.9611 114.318 24.6721 113.434 24.6721C111.649 24.6721 109.831 25.6531 109.831 27.4861C109.831 29.1591 111.295 30.2361 112.935 30.2361C114.189 30.2361 114.881 29.6731 115.315 29.0131H115.379V29.9781H117.181V25.1851C117.182 22.9671 115.524 21.7291 113.386 21.7291ZM113.16 28.5801C112.55 28.5801 111.697 28.2741 111.697 27.5181C111.697 26.5531 112.759 26.1831 113.676 26.1831C114.495 26.1831 114.882 26.3601 115.38 26.6011C115.235 27.7601 114.238 28.5801 113.16 28.5801ZM123.743 22.0021L121.604 27.4221H121.54L119.32 22.0021H117.31L120.639 29.5771L118.741 33.7911H120.687L125.818 22.0021H123.743ZM106.937 30.0001H108.802V17.4991H106.937V30.0001Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5046_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4359 7.53803C10.1449 7.84603 9.9729 8.32403 9.9729 8.94303V31.059C9.9729 31.679 10.1449 32.156 10.4359 32.464L10.5099 32.536L22.8989 20.147V20.001V19.855L10.5099 7.46503L10.4359 7.53803Z",
    fill: "url(#paint0_linear_5046_85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0279 24.278L22.8989 20.147V20.001V19.855L27.0289 15.725L27.1219 15.778L32.0149 18.558C33.4119 19.352 33.4119 20.651 32.0149 21.446L27.1219 24.226L27.0279 24.278Z",
    fill: "url(#paint1_linear_5046_85)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5046_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 24.225L22.8978 20.001L10.4358 32.464C10.8958 32.952 11.6568 33.012 12.5138 32.526L27.1218 24.225Z",
    fill: "url(#paint2_linear_5046_85)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1218 15.777L12.5138 7.47701C11.6568 6.99001 10.8958 7.05101 10.4358 7.53901L22.8988 20.002L27.1218 15.777Z",
    fill: "url(#paint3_linear_5046_85)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.918 11.8203L43.0898 9.11719H45.1094V13.2422H42.5312V13.2109C42.8008 12.8945 42.8789 12.4609 42.918 11.8203ZM41.9141 14H45.8867V15.1133H46.6875V13.2422H45.9844V8.36328H42.3125L42.1055 11.7812C42.0625 12.5273 41.9219 13.0078 41.5195 13.2422H41.1094V15.1133H41.9141V14ZM49.8945 8.26953C48.2695 8.26953 47.2539 9.39062 47.2539 11.1836C47.2539 12.9766 48.2695 14.0938 49.8945 14.0938C51.5156 14.0938 52.5352 12.9766 52.5352 11.1836C52.5352 9.39062 51.5156 8.26953 49.8945 8.26953ZM49.8945 9.03906C50.9648 9.03906 51.6367 9.86719 51.6367 11.1836C51.6367 12.4961 50.9648 13.3242 49.8945 13.3242C48.8242 13.3242 48.1484 12.4961 48.1484 11.1836C48.1484 9.86719 48.8242 9.03906 49.8945 9.03906ZM55.8398 14.1055C57.1055 14.1055 57.9766 13.4492 58.2188 12.332H57.3398C57.1406 12.9609 56.5977 13.3281 55.8438 13.3281C54.8086 13.3281 54.1523 12.4961 54.1523 11.1797C54.1523 9.875 54.8164 9.03516 55.8398 9.03516C56.5703 9.03516 57.1562 9.46875 57.3398 10.1367H58.2188C58.0312 9.01172 57.082 8.25781 55.8398 8.25781C54.2656 8.25781 53.2539 9.39453 53.2539 11.1797C53.2539 12.9766 54.2539 14.1055 55.8398 14.1055ZM61.1211 14V9.11719H62.875V8.36328H58.4883V9.11719H60.2461V14H61.1211ZM64.3242 14.043C65.2148 14.043 65.6758 13.5977 66.1953 12.3867L67.9219 8.36328H67.0078L65.6289 11.8281H65.5977L64.1719 8.36328H63.2422L65.1484 12.7461C64.9336 13.1211 64.6641 13.2734 64.2734 13.2734C64.1211 13.2734 64.0117 13.2539 63.9492 13.2383V13.9922C64 14.0156 64.1523 14.043 64.3242 14.043ZM73.1719 14V8.36328H68.6055V14H69.4844V9.125H72.3047V14H73.1719ZM78.9531 14V8.36328H78.0781V10.7461H75.1836V8.36328H74.3086V14H75.1836V11.5039H78.0781V14H78.9531ZM82.5352 8.26953C80.9102 8.26953 79.8945 9.39062 79.8945 11.1836C79.8945 12.9766 80.9102 14.0938 82.5352 14.0938C84.1562 14.0938 85.1758 12.9766 85.1758 11.1836C85.1758 9.39062 84.1562 8.26953 82.5352 8.26953ZM82.5352 9.03906C83.6055 9.03906 84.2773 9.86719 84.2773 11.1836C84.2773 12.4961 83.6055 13.3242 82.5352 13.3242C81.4648 13.3242 80.7891 12.4961 80.7891 11.1836C80.7891 9.86719 81.4648 9.03906 82.5352 9.03906ZM90.2578 14C91.4609 14 92.1836 13.3984 92.1836 12.4062C92.1836 11.6562 91.6641 11.1133 90.9023 11.0273V10.9961C91.4648 10.9023 91.9023 10.3672 91.9023 9.76953C91.9023 8.91797 91.2461 8.36328 90.25 8.36328H87.9414V14H90.2578ZM88.8164 9.07812H90.0352C90.6719 9.07812 91.0312 9.36719 91.0312 9.89062C91.0312 10.4492 90.6133 10.7617 89.8516 10.7617H88.8164V9.07812ZM88.8164 13.2852V11.4297H90.0312C90.8555 11.4297 91.2891 11.7422 91.2891 12.3516C91.2891 12.9609 90.8711 13.2852 90.082 13.2852H88.8164Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 39,
    rx: 6.5,
    stroke: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5046_85",
    x: 9.9729,
    y: 7.14093,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5046_85"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5046_85",
    result: "effect2_innerShadow_5046_85"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5046_85",
    x: 10.4358,
    y: 20.001,
    width: 16.686,
    height: 12.8607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5046_85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5046_85",
    x1: 21.8007,
    y1: 8.70903,
    x2: 5.0187,
    y2: 25.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5046_85",
    x1: 33.8334,
    y1: 20.001,
    x2: 9.63753,
    y2: 20.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5046_85",
    x1: 24.8279,
    y1: 22.2949,
    x2: 2.06939,
    y2: 45.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5046_85",
    x1: 7.29719,
    y1: 0.176806,
    x2: 17.4595,
    y2: 10.3391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBlack);
export default __webpack_public_path__ + "static/media/googlePlayBlack.7422bb1493efb9a812c2e09f05711e73.svg";
export { ForwardRef as ReactComponent };